module.exports = __webpack_public_path__ + "static/cp2077_1-fc6264fc455f61836cc285be48d7388f.webp";